/**
 * Settings Module
 */
import {
  layoutList,
  richMenuImageTemplate,
  richMenuSize
} from './data'

const getDefaultState = () => {
  return {
    layoutList,
    richMenuImageTemplate,
    richMenuSize,
    richMenu: {
      moduleChannelId: '',
      richName: '',
      layoutType: '',
      status: 'UNUSED',
      size: {
        width: 900, // 추후 탭전환 생기면 세로 606px로 보내어야함.
        height: 500
      },
      contents: [{ // 탭전환을 위해 배열 형태 프론트화면 어덯게 나올지 몰라서 현재는 1개 기준으로 개발 되어 content[0]으로 대응
        name: 'tabName', // 추후 개발 예정
        image: '',
        selected: true,
        chatBarText: 'メニュー',
        areas: []
      }]
    }
  }
}

const state = getDefaultState()
// getters
const getters = {
  layoutList: state => {
    return state.layoutList
  },
  richMenuSize: state => {
    return state.richMenuSize
  },
  richMenu: state => {
    return state.richMenu
  },
  lineChannelId: state => {
    return state.richMenu.moduleChannelId
  },
  richMenuName: state => {
    return state.richMenu.richName
  },
  richMenuLayoutType: state => {
    return state.richMenu.layoutType
  },
  richMenuLayoutLength: state => {
    return state.richMenu.contents[0].areas.length
  },
  richMenuContent: state => {
    return state.richMenu.contents[0]
  },
  richMenuImageTemplate: state => {
    return state.richMenuImageTemplate
  },
  richMenuBarSelected: state => {
    return state.richMenu.contents[0].selected
  }
}

// actions
const actions = {
}

// mutations
const mutations = {
  addRichMenuArea (state, data) {
    let index = state.richMenu.contents[0].areas.length
    state.richMenu.contents[0].areas.push({
      index: index,
      area: String.fromCharCode(65 + index),
      type: 'url',
      value: '',
      image: '',
      bounds: {
        x: data.size.x,
        y: data.size.y,
        width: data.size.width,
        height: data.size.height,
        value: data.size.value
      }
    })
  },
  setLineChannelId (state, data) {
    state.richMenu.moduleChannelId = data
  },
  setRichMenuName (state, menuName) {
    state.richMenu.richName = menuName
  },
  setRichMenu (state, richMenu) {
    state.richMenu = richMenu
  },
  setRichMenuBarTitle (state, title) {
    state.richMenu.contents[0].chatBarText = title
  },
  setRichMenuBar (state, value) {
    state.richMenu.contents[0].selected = value
  },
  setRichMenuInfo (state, value) {
    state.richMenu = value
  },
  setDefalutMenuInfo (state) {
    state.richMenu = {
      moduleChannelId: '',
      richName: '',
      layoutType: '',
      status: 'UNUSED',
      size: {
        width: 900,
        height: 500
      },
      contents: [{
        name: 'tabName',
        image: '',
        selected: true,
        chatBarText: 'メニュー',
        areas: []
      }]
    }
  },
  resetContents (state) {
    state.richMenu.contents[0].image = ''
    state.richMenu.contents[0].areas = []
  },
  setRichMenuLayout (state, type) {
    state.layoutList.map(d => {
      d.selected = false
    })
    state.layoutList.map(d => {
      if (d.type === type) {
        d.selected = true
        state.richMenu.layoutType = type
        state.richMenu.contents[0].areas = []
      }
    })
  },
  setRichMenuLayoutSelecgtedReset (state) {
    state.layoutList.map(d => {
      d.selected = false
    })
  },
  setRichMenuEdit (state, data) {
    state.richMenu.contents[0].areas[data.index] = data
  },
  setRichMenuInfoLayout (state, data) {
    state.richMenu.layoutType = data
  },
  setRichMenuContentImage (state, data) {
    state.richMenu.contents[0].image = data
  },
  validAreasData (state) {
    state.richMenu.contents[0].areas.forEach(d => {
      if (d.image && d.value) {
        return true
      } else {
        return false
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/marketingRich/index.js